import { render, staticRenderFns } from "./BotFlowEditor.vue?vue&type=template&id=331ef52e&scoped=true"
import script from "./BotFlowEditor.vue?vue&type=script&lang=js"
export * from "./BotFlowEditor.vue?vue&type=script&lang=js"
import style0 from "./BotFlowEditor.vue?vue&type=style&index=0&id=331ef52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331ef52e",
  null
  
)

export default component.exports